<template>
    <div>
        <div v-if="consultationSet.length === 0" class="w3-center flow-blue-color">
            <b class="font-size-1pt25em">{{$t("noRoomsLinked")}}</b>
        </div>
        <div v-else v-for="each in consultationSet" class="flow-card blue-top w3-margin-bottom w3-padding">
            <div>
                <h6 class="consultation-group w3-show-inline-block font-weight-bold">{{each.physician.name}}</h6>
                <span class="consultation-room w3-round-medium font-weight-bold flow-margin-left flow-padding">{{$t(each.physician.status)}}</span>
            </div>

            <div class="w3-row w3-padding-large">
                <div class="w3-half w3-margin-bottom" v-for="consultation in each.consultations">
                    <router-link :to="{name: 'room', params: {roomId: consultation.room.id}}"
                                 :title="consultation.room.name">
                        <h6 v-show="consultation.room.name"
                            class="font-weight-bold w3-show-inline-block flow-blue-color w3-border-bottom">
                            {{consultation.room.name}}</h6>
                    </router-link>
                    <patient-status class="w3-show-inline-block w3-margin-right"
                                    :status="consultation.patient ? 'InConsultation' : 'LeftConsultation'"
                                    :showMarker="true">
                    </patient-status>
                    <router-link :to="{name: 'room', params: {roomId: consultation.room.id}}"
                                 :title="consultation.room.name">

                        <span v-if="consultation.patient">{{consultation.patient.name}}</span>
                    </router-link>
                    <br/>

                    <button v-if="consultation.patient"
                            class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium"
                            @click.prevent="recallAppointment(consultation.patient.id, consultation.appointmentId)">
                        <i class="fa fa-bullhorn flow-green-active-color">
                            <span><b class="flow-margin-left">{{$t('callPatientAgain')}}</b></span>
                        </i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import PatientStatus from "../common/PatientStatus";
    import {EventBus} from "../../main";

    const frc = Vue.prototype.$frc;

    export default {
        name: "ConsultationsInWard",
        components: {PatientStatus},
        data() {
            return {
                consultationSet: [],
                refreshIntervalId: undefined
            }
        },
        mounted() {
            this.getConsultationsInWard();
            this.refreshIntervalId = setInterval(this.getConsultationsInWard, 10000);
            EventBus.$on("wardUpdated", this.getConsultationsInWard);
        },
        beforeDestroy() {
            clearInterval(this.refreshIntervalId);
            EventBus.$off("wardUpdated", this.getConsultationsInWard);
        },
        methods: {
            getConsultationsInWard() {
                var app = this;
                frc.getConsultationsInWard(Vue.prototype.$currentWard.id).then(function (res) {
                    app.consultationSet = res.data;
                }).catch(function (ex) {
                    console.log(ex);
                });
            }
        }
    }
</script>

<style scoped>

</style>